export class HouseholdMember {
    constructor(){}
    
    id: string;
    relationship: string;
    age: number;
    american_indian: boolean;
    pacific_islander: boolean;
    african_american: boolean;
    asain: boolean;
    white: boolean;
    hispanic: number;
}


// WEBPACK FOOTER //
// ./src/app/_models/household-member.ts